import { useMetaLibraryContext } from '../contexts/meta-library.context';

/**
 * Hook pour accéder à la meta library depuis le contexte.
 * Les données sont mises en cache et ne sont rechargées que si l'organisation change.
 */
export const useMetaLibrary = () => {
  return useMetaLibraryContext();
};

